let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page045_game10/img/bcg.jpg',
    width: 1430,
    height: 610,
    pos: {
      x: 226,
      y: 296,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Wciśnij klawisz Caps Lock.',
      },
      audio: {
        src: 'games/page045_game10/audio/z22s45-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 452,
        y: 516,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Sprawdź, czy zaświeciło się światełko Caps Lock.',
      },
      audio: {
        src: 'games/page045_game10/audio/z22s45-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1512,
        y: 296,
      },
    },
  ],
};
export default elements;
